import { useState, useEffect } from 'react';
import api from '../services/api';

const ROLES = ['superadmin', 'admin', 'viewer'];

function Modal({ onClose, onSave }) {
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'admin' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try { await onSave(form); onClose(); }
    catch (err) { setError(err.response?.data?.message || 'Error al crear usuario'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.modalHead}>
          <span style={s.modalTitle}>Nuevo usuario</span>
          <button onClick={onClose} style={s.closeBtn}>✕</button>
        </div>
        {error && <div style={s.err}>{error}</div>}
        <form onSubmit={handle} style={{ padding: '24px' }}>
          {[['Nombre completo','name','text'],['Correo electrónico','email','email'],['Contraseña','password','password']].map(([label,key,type]) => (
            <div key={key} style={{ marginBottom: 16 }}>
              <label style={s.label}>{label}</label>
              <input style={s.input} type={type} required value={form[key]}
                onChange={e => setForm({...form, [key]: e.target.value})} />
            </div>
          ))}
          <div style={{ marginBottom: 24 }}>
            <label style={s.label}>Rol</label>
            <select style={s.input} value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
              {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <button type="submit" style={s.btnPrimary} disabled={loading}>
            {loading ? 'Creando...' : 'Crear usuario'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default function Usuarios() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/auth/users');
      setUsers(res.data.data || []);
    } catch { setUsers([]); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const createUser = async (form) => {
    await api.post('/api/auth/create-user', form);
    load();
  };

  const fmt = iso => iso ? new Date(iso).toLocaleDateString('es-MX') : '—';

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Equipo</h1>
          <p style={s.sub}>Usuarios con acceso al dashboard</p>
        </div>
        <button style={s.btnPrimary} onClick={() => setShowModal(true)}>+ Nuevo usuario</button>
      </div>

      <div style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>{['Nombre','Email','Rol','Último acceso','Creado'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {loading ? <tr><td colSpan={5} style={s.empty}>Cargando...</td></tr>
            : users.length === 0 ? <tr><td colSpan={5} style={s.empty}>Sin usuarios</td></tr>
            : users.map(u => (
              <tr key={u.id} style={s.tr}>
                <td style={s.td}><strong>{u.name}</strong></td>
                <td style={s.td}>{u.email}</td>
                <td style={s.td}><span style={{...s.badge, background: u.role==='superadmin'?'#111':'#f0f0f0', color: u.role==='superadmin'?'#fff':'#555'}}>{u.role}</span></td>
                <td style={s.td}>{fmt(u.last_login)}</td>
                <td style={s.td}>{fmt(u.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && <Modal onClose={() => setShowModal(false)} onSave={createUser} />}
    </div>
  );
}

const s = {
  header: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:28 },
  title: { fontSize:24, fontWeight:700, margin:'0 0 4px', color:'#111', fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:-0.5 },
  sub: { fontSize:13, color:'#888', margin:0 },
  tableWrap: { background:'#fff', borderRadius:2, border:'1px solid #eee', overflow:'hidden' },
  table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th: { background:'#fafafa', textAlign:'left', padding:'12px 16px', fontWeight:600, color:'#888', fontSize:11, textTransform:'uppercase', letterSpacing:'0.5px', borderBottom:'1px solid #eee' },
  tr: { borderBottom:'1px solid #f5f5f5' },
  td: { padding:'12px 16px', verticalAlign:'middle' },
  empty: { textAlign:'center', padding:40, color:'#bbb' },
  badge: { padding:'3px 10px', borderRadius:2, fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:1 },
  btnPrimary: { background:'#111', color:'#fff', border:'none', padding:'10px 20px', fontSize:12, fontWeight:600, letterSpacing:2, textTransform:'uppercase', cursor:'pointer', fontFamily:"'Barlow',sans-serif" },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
  modal: { background:'#fff', width:'100%', maxWidth:440, borderRadius:2 },
  modalHead: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'20px 24px', borderBottom:'1px solid #eee' },
  modalTitle: { fontSize:15, fontWeight:600, fontFamily:"'Barlow Condensed',sans-serif", textTransform:'uppercase', letterSpacing:1 },
  closeBtn: { background:'none', border:'none', cursor:'pointer', fontSize:16, color:'#888' },
  err: { background:'#fff0f0', borderLeft:'3px solid #dc1414', color:'#b91c1c', padding:'10px 16px', fontSize:13, margin:'0 24px' },
  label: { display:'block', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', color:'#555', marginBottom:6 },
  input: { width:'100%', padding:'10px 14px', border:'1.5px solid #e5e5e5', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:"'Barlow',sans-serif", borderRadius:0 },
};
